export const repositoryClear = 'REPOSITORY_CLEAR';
export const repositoryFetch = 'REPOSITORY_FETCH';
export const repositorySelected = 'REPOSITORY_SELECTED';

export default {
    clear: repositoryClear,
    fetch: repositoryFetch,
    selected: repositorySelected
};
